export default __webpack_public_path__ + "static/media/downloadFile.89eeffa9.svg";